<template>
    <div v-if="errorObject" class="mini-cart-product-error">
        <button type="button" class="remove-product" @click="remove">{{item.resources.removeLabel}}</button>
        <div :class="['inline-alert', errorObject.type]">
            <span>{{errorObject.message}}</span>
        </div>
    </div>
</template>

<script src="./mini-cart-line-error.js"></script>
